import {ToggleButton} from '@github-ui/pacer/ToggleButton'
import {TasklistIcon} from '@primer/octicons-react'
import {useCallback} from 'react'

import {useChatState} from '../utils/CopilotChatContext'
import {useChatManager} from '../utils/CopilotChatManagerContext'

export function PlanningIntentToggle() {
  const manager = useChatManager()
  const {usePlanningIntent} = useChatState()
  const onClick = useCallback(() => manager.setUsePlanningIntent(!usePlanningIntent), [manager, usePlanningIntent])

  return (
    <ToggleButton icon={<TasklistIcon />} isSelected={usePlanningIntent} onClick={onClick}>
      Plan
    </ToggleButton>
  )
}

try{ PlanningIntentToggle.displayName ||= 'PlanningIntentToggle' } catch {}